const EnvConfig = {
  IS_LOCAL: false,
  PAGE_ID: '611879859276426',
  APP_ID: '2021643014798876',
  HTML_REF: 'https://api.sunphar.com.vn',
  REACT_APP_API_URL: "https://api.sunphar.com.vn", // use 'production'
  PAGE_TITLE: 'sunfrance.linkphar.com - Phần mềm quản lý dược số 1 Việt Nam, Dễ dùng và Tiết kiệm chi phí!'
};
  
export default EnvConfig;
  


// WEBPACK FOOTER //
// ./src/config/env.js